import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DossierKYC, KycApprover } from '../models/dossier';
import { Message } from '../models/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DossierKycService {

  constructor(private httpClient: HttpClient) { }

   public createKyc(kyc: DossierKYC): Observable<Message> {
      return this.httpClient.post<Message>('/api/dossier/v1/kyc', kyc);
    }
  
    public getKycs(employeeId : number, disabled?: boolean): Observable<DossierKYC[]> {
      return this.httpClient.get<DossierKYC[]>('/api/dossier/v1/kycs', { params: { employeeId, ...(disabled && { disabled }) } });
    }

    public getApproverKycs(verifierId   : number, disabled?: boolean): Observable<KycApprover[]> {
      return this.httpClient.get<KycApprover[]>('/api/dossier/v1/kycs/verifier', { params: { verifierId  , ...(disabled && { disabled }) } });
    }
  
    public getKyc(id: number): Observable<DossierKYC> {
      return this.httpClient.get<DossierKYC>(`/api/dossier/v1/kyc/${id}`);
    }
  
    public updateKyc(id: number, kyc: DossierKYC): Observable<Message> {
      return this.httpClient.put<Message>(`/api/dossier/v1/kyc/${id}`, kyc);
    }
  
    public deleteKyc(id: number): Observable<Message> {
      return this.httpClient.delete<Message>(`/api/dossier/v1/kyc/${id}`);
    }

    public uploadKyc(kycId: number,file?: FormData): Observable<Message> {
      return this.httpClient.put<Message>(`/api/dossier/v1/kyc/upload?kycId=${kycId}`, file);
    }
  
}
